import { createBrowserRouter } from 'react-router-dom';
import Layout from '@/components/Layout';
import HomePage from '@/pages/HomePage';
import PillarsPage from '@/pages/PillarsPage';
import ReviewPage from '@/pages/ReviewPage';
import QuizPage from '@/pages/QuizPage';
import ProfilesPage from '@/pages/ProfilesPage';
import SearchPage from '@/pages/SearchPage';
import ModerationPage from '@/pages/ModerationPage';
import NotFound from '@/pages/NotFound';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <NotFound />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'pilastri',
        element: <PillarsPage />,
      },
      {
        path: 'recensione',
        element: <ReviewPage />,
      },
      {
        path: 'quiz',
        element: <QuizPage />,
      },
      {
        path: 'profili',
        element: <ProfilesPage />,
      },
      {
        path: 'ricerca',
        element: <SearchPage />,
      },
      {
        path: 'moderazione',
        element: <ModerationPage />,
      },
    ],
  },
]);